import * as UserType        from '../shared/types/User';
import * as AgencyType      from '../shared/types/Agency';

import Menu                 from './Menu';
import getApiPromise        from './getApiPromise';

class InteliTransIT {

    private clearConsoleInterval?       : number;
    public  menu                        : Menu   = { isOpen:false };
    public  readonly timeFormat         : string = "MM/DD/YYYY HH:mm";
    public  user                        : (UserType.User|undefined);
    // @ts-expect-error
    public  agency                      : AgencyType.Agency & {
        startup_ms  : number;
    };

    private startGarbageMessagesJanitor() {
        // See https://stackoverflow.com/questions/39152877/consider-marking-event-handler-as-passive-to-make-the-page-more-responsive?noredirect=1&lq=1
        // If I do not do this on a timer then the messages accumulate and can eventually eat browser resources
        this.clearConsoleInterval = window.setInterval(() => {
            console.clear();
        },120000);
    }
    async init() : Promise<boolean> {
        const userAndAgency = await Promise
            .all([
                getApiPromise<UserType.Dehydrated>('/api/public/user'),
                getApiPromise<AgencyType.Agency>('/api/public/agency')
            ])
            .then( ([dehydratedUser,agency]) => {
                if( !dehydratedUser || dehydratedUser.err )
                    return [undefined,agency];
                const user = UserType.hydrate(dehydratedUser);
                if( !user.roles )
                    user.roles = [];
                if( !user.roles.length )
                    user.roles = [];
                if( !agency || agency.err ) {
                    window.location.href = `/auth/index?${(new URLSearchParams({err:(agency?.err||'agency is empty')})).toString()}`;
                    return [user,undefined];
                }
                return [user,agency];
            });
        this.user   = userAndAgency[0] as typeof this.user;
        this.agency = userAndAgency[1] as typeof this.agency;
        if( !this.agency )
            return false;
        this.startGarbageMessagesJanitor();
        return true;
    }
}

const inteliTransIT = new InteliTransIT();

export default inteliTransIT;
